import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Radio } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { $t } from "~/i18n.js";
import { all_start_methods } from "~/redux/flights/flights.state.js";

export const SectionStartmethode = ({
  readOnly,
  flight,
  saveFlight,
  size = "medium",
  extra_methods = [],
  maxWidth = 500,
}) => {
  // createNewSleepFlight: only for club tijdschrijven, not for private admin, if sleep selected it will generate a second new flight for the sleepvliegtuig
  const [start_methode, setStartMethod] = useState(flight.start_methode);
  const [loading, setLoading] = useState(false);

  const { club } = useSelector((state) => state.persist);
  const club_methods = club.start_methods?.split(",") || ["lier", "sleep"];
  const other_methods = extra_methods
    .concat(all_start_methods)
    .filter((m) => !club_methods.includes(m));
  const other_method_items = other_methods.map((method) => ({
    key: method,
    label: $t(method),
    disabled: readOnly || loading,
  }));
  const isOtherMethod = !club_methods.includes(start_methode);

  useEffect(() => {
    setStartMethod(flight.start_methode);
    setLoading(false);
  }, [flight.uuid, flight.start_methode]);

  const triggerStartMethode = async (method) => {
    setStartMethod(method);
    setLoading(true);
    await saveFlight({ start_methode: method });
    setLoading(false);
  };

  return (
    <div className="column" style={{ alignItems: "flex-start", marginTop: 12 }}>
      <div
        className="row spacer"
        style={{ flexWrap: "wrap", maxWidth: maxWidth }}
      >
        <Radio.Group
          size={size}
          buttonStyle="solid"
          disabled={readOnly}
          loading={loading}
          value={start_methode}
          onChange={(e) => {
            !loading && triggerStartMethode(event.target.value);
          }}
        >
          {club_methods.map((method, index) => (
            <Radio.Button key={index} value={method}>
              {$t(method)}
            </Radio.Button>
          ))}

          <Dropdown
            key="other"
            disabled={readOnly || loading}
            menu={{
              items: other_method_items,
              onClick: (e) => {
                !loading && triggerStartMethode(e.key);
              },
            }}
            placement="bottom"
          >
            <Button
              key="otherKey"
              size={size}
              disabled={readOnly}
              loading={loading}
              type={isOtherMethod ? "primary" : "default"}
              style={{
                borderBottomLeftRadius: 0,
                borderTopLeftRadius: 0,
                padding: "4px 10px",
              }}
            >
              {isOtherMethod ? $t(start_methode) : $t("anders")}{" "}
              <DownOutlined />
            </Button>
          </Dropdown>
        </Radio.Group>
      </div>
    </div>
  );
};
